import React from 'react';

function fmtMoney(n) {
  const num = Number(n);
  if (Number.isNaN(num)) return '—';
  return `$${num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export default function PortfolioImpactCard({ position, portfolioValue, portfolioImpact }) {
  if (!position) {
    return (
      <div className="dashboard-section">
        <h3>Your Position</h3>
        <div className="empty-state">
          <p>You do not currently hold this stock</p>
        </div>
      </div>
    );
  }

  const pl = Number(position.unrealized_pl);
  const value = Number(position.market_value);
  const pctOfPortfolio = portfolioValue > 0 ? (value / portfolioValue) * 100 : null;

  return (
    <div className="dashboard-section">
      <h3>Your Position</h3>
      <div className="stats-grid">
        <div className="stat-card">
          <p className="stat-label">Shares</p>
          <p className="stat-value">{position.qty}</p>
        </div>
        <div className="stat-card">
          <p className="stat-label">Avg Cost</p>
          <p className="stat-value">{fmtMoney(position.avg_entry_price)}</p>
        </div>
        <div className="stat-card">
          <p className="stat-label">Current Value</p>
          <p className="stat-value">{fmtMoney(value)}</p>
        </div>
        <div className="stat-card">
          <p className="stat-label">Unrealized P/L</p>
          <p className={`stat-value ${pl >= 0 ? 'up' : 'down'}`}>
            {pl >= 0 ? '+' : ''}
            {fmtMoney(pl)}
          </p>
        </div>
        {pctOfPortfolio != null && (
          <div className="stat-card">
            <p className="stat-label">% of Portfolio</p>
            <p className="stat-value">{pctOfPortfolio.toFixed(1)}%</p>
          </div>
        )}
      </div>
      {portfolioImpact && <p className="reasoning" style={{ marginTop: 14 }}>{portfolioImpact}</p>}
    </div>
  );
}
